import store from '../../store';

export default class WhatsAppCallPermissionReplyEvent {
  constructor(body) {
    window.console.log(
      '[WhatsAppCallPermissionReplyEvent]',
      JSON.parse(JSON.stringify(body)),
    );

    const { response,permanent,expirationTimestamp } = body;

    const job = store.state.jobs.jobList.find(job => job.channel.toLowerCase() === 'whatsapp' && job.metaType.toLowerCase() === 'whatsapp' && job.from === `${from}@${to}`);


    if (job) {

      const protocol = job.protocol;

      store.dispatch('jobs/updateJob', { protocol,
        value:response,
        property: 'whatsAppVoice',
      });

      store.dispatch('jobs/updateJob', { protocol,
        value: permanent,
        property: 'whatsAppVoiceWindowPermanent',
      });

      //store.dispatch('jobs/updateJob', { protocol,
      //  value: expirationTimestamp,
      //  property: 'whatsAppVoiceDate',
      //});
    }
  }
}
